import { SVGProps } from "react";

export default function ImageFileIcon(props: SVGProps<SVGSVGElement>) {
  const { width = 16, height = 16, stroke = "#444D5A", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.4539 11.3064L12.3673 6.43309C11.6606 4.77976 10.3606 4.71309 9.48727 6.28643L8.22727 8.55976C7.58727 9.71309 6.39394 9.81309 5.56727 8.77976L5.4206 8.59309C4.5606 7.51309 3.34727 7.64643 2.72727 8.87976L1.5806 11.1798C0.773935 12.7798 1.9406 14.6664 3.72727 14.6664H12.2339C13.9673 14.6664 15.1339 12.8998 14.4539 11.3064Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M4.64844 5.33301C5.75301 5.33301 6.64844 4.43758 6.64844 3.33301C6.64844 2.22844 5.75301 1.33301 4.64844 1.33301C3.54387 1.33301 2.64844 2.22844 2.64844 3.33301C2.64844 4.43758 3.54387 5.33301 4.64844 5.33301Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
